export default "__VITE_ASSET___Yy9p7oS__"